export default {
  data() {
    return {
      entries: [],
    };
  },
  methods: {

    async editScheduledEntries(...entries) {
      this.entries = entries;

      const modal_response = await this.fireModal('edit-scheduled-entries');

      if (!modal_response.data.confirm) {
        return false;
      }

      const modal_response_data = await modal_response.data;

      let changes = 0;

      const post_data = {};
      if (modal_response_data.showname) {
        post_data.name = modal_response_data.showname;
        changes++;
      }

      if (modal_response_data.description) {
        post_data.description = modal_response_data.description;
        changes++;
      }

      if (modal_response_data.tags) {
        post_data.tags = modal_response_data.tags;
        changes++;
      }

      if (modal_response_data.image) {
        post_data.image = modal_response_data.image;
        changes++;
      }

      if (modal_response_data.broadcaststart) {
        post_data.start = modal_response_data.broadcaststart;
        changes++;
      }

      if (modal_response_data.broadcaststop) {
        post_data.stop = modal_response_data.broadcaststop;
        changes++;
      }

      if (modal_response_data.publishstart) {
        post_data.publish_start = modal_response_data.publishstart;
        changes++;
      }

      if (modal_response_data.publishstop) {
        post_data.publish_stop = modal_response_data.publishstop;
        changes++;
      }

      if (modal_response_data.publish_duration) {
        post_data.publish_duration = modal_response_data.publish_duration;
        changes++;
      }

      if (modal_response_data.publish_start_delay) {
        post_data.publish_start_delay = modal_response_data.publish_start_delay;
        changes++;
      }

      if (modal_response_data.publish_stop_delay) {
        post_data.publish_stop_delay = modal_response_data.publish_stop_delay;
        changes++;
      }

      if (modal_response_data.recur_from) {
        post_data.recur_from = modal_response_data.recur_from;
        changes++;
      }

      if (modal_response_data.recur_until) {
        post_data.recur_until = modal_response_data.recur_until;
        changes++;
      }

      if (modal_response_data.freq) {
        post_data.freq = modal_response_data.freq;
        changes++;
      }

      if (modal_response_data['weekly-days']) {
        post_data['weekly-days'] = modal_response_data['weekly-days'];
        changes++;
      }

      post_data.is_overridden = modal_response_data.is_overridden;
      changes++;

      if (changes > 0) {
        try {
          const edit_response = await axios.post('/api/v1/scheduler/edit',
            {
              entries,
              payload: post_data,
            },
          );

          return edit_response;
        } catch (error) {
          toastr.error(error?.response?.data?.error?.message ?? error?.message ?? "Something went wrong");
        }
      }

      return;
    },
  },
};
